export const HIGHLIGHT_COLORS = {
  orange: '#FFA163',
  yellow: '#FFEA4C',
  blue: '#4CF3FF',
} as const;

export type HighlightColor = keyof typeof HIGHLIGHT_COLORS;

export const HIGHLIGHT_COLOR_LABELS: Record<HighlightColor, string> = {
  orange: 'Orange',
  yellow: 'Yellow',
  blue: 'Blue',
};
